<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import type { DealTier } from "@shared/types/Deals";

  export let deal: DealTier[];
  export let dealTierId: number;
  export let isRip: boolean = false;

</script>

<div data-grid-area="section" class="fizz-margin-auto">
  <div class="fizz-scroll-horizontal" style="max-width: calc(100vw - 2rem);">
    <span class="fizz-button-group">
      {#each deal as tier}
        <UIRouterLink
          stateName={"layout.deal_detail"}
          id={"deal_tier-" + tier.deal_tier_id}
          params={{ dealId: tier.deal_id, dealTierId: tier.deal_tier_id }}
          opts={{ redirect: true }}
          classes={"fizz-button-small" +
            (tier.deal_tier_id == dealTierId ? " fizz-is-active" : " ")}
        >
          {tier.tier_min_label}<br />
          {#if isRip}
            ${Math.round(Number(tier.tier_discount_amount))} RIP
          {:else}
            {tier.tier_max_label}
          {/if}
        </UIRouterLink>
      {/each}
    </span>
  </div>
</div>
